import { JsonObject, JsonProperty } from 'json2typescript';

import { SimulationDto } from './simulation-dto.model';

@JsonObject('connectedSimulation')
export class ConnectedSimulation {
  @JsonProperty('indicateurOffreCollab', Boolean, true)
  public isCollaboratorOffer = false;

  @JsonProperty('simulationDTOList', [SimulationDto], true)
  public simulations: SimulationDto[] = [];
}
